import { axiosClient } from '../axiosClient';
import { IntentAction } from './types';

type Params = {
  agentId: number;
  actionType: number;
};

export const getIntentActions = ({ agentId, actionType }: Params) => {
  return axiosClient.get<IntentAction[]>(`/agents/${agentId}/actions`, {
    params: { actionType },
  });
};
